import React from 'react';
import { User } from '../../usersTypes';
import TableCell from '../../../components/table/TableCell';

type Props = {
  user: User;
};

const UserEmailTableCell = ({ user }: Props) => {
  return <TableCell>{user.email}</TableCell>;
};

export default UserEmailTableCell;
